import React from "react";
import MyContact from "./MyContact";
import Slide from 'react-reveal/Slide';

const Contact = () => {

  return <>
  <Slide bottom >
    <MyContact />
    </Slide>
  </>;
};

export default Contact;
